const state = {
    showChatModal: false,
    currentChatMode: null,
}

const mutations = {
    SET_SHOW_CHAT_MODAL (state, showChatModal) {
        state.showChatModal = showChatModal
    },
    SET_CURRENT_CHAT_MODE (state, chatMode) {
        state.currentChatMode = chatMode
    },
}
const actions = {
    async setShowChatModal (store, showChatModal) {
        store.commit('SET_SHOW_CHAT_MODAL', showChatModal)
    },
    async setCurrentChatMode (store, chatMode) {
        store.commit('SET_CURRENT_CHAT_MODE', chatMode)
    },
}

const getters = {
    getCurrentChatMode: state => {
        return state.currentChatMode
    },
    getShowChatModal: state => {
        return state.showChatModal
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
